var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#0774B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5156 23.5H8.24609V12.9883H11.5156V23.5ZM9.86328 11.582C8.84375 11.582 8 10.7031 8 9.64844C8 8.20703 9.54688 7.29297 10.8125 8.03125C11.4102 8.34766 11.7617 8.98047 11.7617 9.64844C11.7617 10.7031 10.918 11.582 9.86328 11.582ZM23.7148 23.5H20.4805V18.4023C20.4805 17.1719 20.4453 15.625 18.7578 15.625C17.0703 15.625 16.8242 16.9258 16.8242 18.2969V23.5H13.5547V12.9883H16.6836V14.4297H16.7188C17.1758 13.6211 18.2305 12.7422 19.8125 12.7422C23.1172 12.7422 23.75 14.9219 23.75 17.7344V23.5H23.7148Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinHover);
export default __webpack_public_path__ + "static/media/linkedin-hover.992ec03a5d8852e79fc90b704d711e8e.svg";
export { ForwardRef as ReactComponent };